import React, { FC } from 'react'

import { IconType } from '../../common/types'

const NucHome: FC<IconType> = ({ iconColor = 'currentColor', ...svgProps }) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 25 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M24.832 11.75C24.832 12.5234 24.1875 13.125 23.457 13.125H22.082L22.125 20C22.125 20.1289 22.125 20.2578 22.125 20.3438V21.0312C22.125 22.0195 21.3516 22.75 20.4062 22.75H19.7188C19.6328 22.75 19.5898 22.75 19.5469 22.75C19.5039 22.75 19.418 22.75 19.375 22.75H16.9688C15.9805 22.75 15.25 22.0195 15.25 21.0312V17.25C15.25 16.5195 14.6055 15.875 13.875 15.875H11.125C10.3516 15.875 9.75 16.5195 9.75 17.25V21.0312C9.75 22.0195 8.97656 22.75 8.03125 22.75H5.625C5.53906 22.75 5.49609 22.75 5.41016 22.75C5.36719 22.75 5.32422 22.75 5.28125 22.75H4.59375C3.60547 22.75 2.875 22.0195 2.875 21.0312V16.2188C2.875 16.2188 2.875 16.1758 2.875 16.1328V13.125H1.5C0.726562 13.125 0.125 12.5234 0.125 11.75C0.125 11.3633 0.253906 11.0195 0.554688 10.7188L11.5547 1.13672C11.8555 0.835938 12.1992 0.75 12.5 0.75C12.8008 0.75 13.1445 0.878906 13.4023 1.09375L24.3594 10.7188C24.7031 11.0195 24.875 11.3633 24.832 11.75Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucHome
